import Vue from 'vue'
import Vant from 'vant'
import App from './App.vue'
import router from './router'
import store from './store/store'
import 'vant/lib/index.css'
import 'vant/lib/icon/local.css';
import './icons' // icon
import wx from 'weixin-js-sdk'
import Toast from './components/bjy_live/Toast/toast.js'


// 引入验证码登录弹窗组件
import codeLogin from './components/common/codeLogin.vue';
Vue.component('code-login',codeLogin)



/**hls直播  .m3u8 不支持rtmp*/
// import hls from 'videojs-contrib-hls'
// Vue.use(hls)

import VideoPlayer from 'vue-video-player'
require('video.js/dist/video-js.css')
require('vue-video-player/src/custom-theme.css')


import VueCanvasPoster from 'vue-canvas-poster'
Vue.use(VueCanvasPoster)

//const Vue = Yox.Vue
// Vue.use(Yox.plugin)
Vue.use(VideoPlayer)

const hls = require('videojs-contrib-hls')
Vue.use(hls)

Vue.use(Vant)

Vue.prototype.$Toast = Toast
Vue.config.productionTip = false
if (process.env.NODE_ENV == 'development') {
  Vue.config.devtools = true;
} else {
  Vue.config.devtools = false;
}

Vue.prototype.$wx = wx

Vue.use(Toast)

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')




